export const extractEmailDomain = (email?: string): undefined | string => {
    if (!email) {
        return;
    }

    const parts = email.split('@');
    if (parts.length !== 2) {
        return;
    }

    const domain = parts[1].split('.')[0];
    if (domain.length === 0) {
        return;
    }

    return domain;
};
